import axios from "axios";

export const fetchCreateParentCompany = async (data: any) => {
  return await axios.post("/api/parentcompany", data);
};
